import {ImmutableStore} from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

class ManageAccountStore extends ImmutableStore {
  static storeName = 'ManageAccountStore';

  static handlers = {
    [Actions.USER_ACCOUNT__EDIT_STARTED]: 'setDefaultState',
    [Actions.USER_ACCOUNT__EDIT_CANCELLED]: 'setDefaultState',
    [Actions.USER_ACCOUNT__EDIT_COMPLETED]: 'setDefaultState',
    [Actions.AUTHENTICATION__PASSWORD_FORGOT_COMPLETED]: 'passwordResetStarted',
    [Actions.USER_ACCOUNT__MESSAGES_CLEARED]: 'clearMessages'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState({
      user: {},
      saved: false,
      passwordResetSent: false
    });
  }

  setDefaultState({ saved = false, passwordResetSent = false } = {}) {
    const state = {
      saved: saved,
      passwordResetSent: passwordResetSent
    };
    this.setState(state);
  }

  getUser() {
    return this.get('user').toJS();
  }

  saved() {
    return this.get('saved') || false;
  }

  passwordResetStarted() {
    console.info('Password reset event captured.  Setting passwordResetSent to true');
    this.mergeState({
      passwordResetSent: true
    });
  }

  passwordResetSent() {
    return this.get('passwordResetSent') || false;
  }

  clearMessages() {
    this.mergeState({
      passwordResetSent: false,
      saved: false
    });
  }

}

export default ManageAccountStore;



// WEBPACK FOOTER //
// ./src/stores/ManageAccountStore.js